import classNames from 'classnames';
import React from 'react';

import ClassroomInvitation from './ClassroomInvitation';
import {useStudentDashboard} from 'client/Classrooms/StudentDashboard/StudentDashboard.store';

interface Props extends PropsWithClassNameOptional {}

export default function ClassroomInvitations({className}: Props) {
  const invitations = useStudentDashboard((state) => state.invitations);

  return (
    <ul className={classNames(className, 'flex list-none flex-col gap-x1 p-x0')}>
      {invitations.map((invitation) => (
        <ClassroomInvitation invitation={invitation} key={invitation.getId()} />
      ))}
    </ul>
  );
}
